import * as CONST from '../ActionTypes';

const initialState = {
  productCategoryList: [],
  productCategory: {},
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  query: {
    currentPage: 0,
    itemsPerPage: 10,
    sort: 'created_at',
    isAsc: false,
    search: '',
  },
};

function productCategory(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // カテゴリーカテゴリー一覧取得
    // -----------------
    case CONST.GET_PRODUCT_CATEGORY_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productCategoryList: action.payload,
        },
      );
    case CONST.GET_PRODUCT_CATEGORY_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productCategoryList: [],
        },
      );
    // -----------------
    // カテゴリー詳細取得
    // -----------------
    case CONST.GET_PRODUCT_CATEGORY_DETAIL_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          productCategory: action.payload,
        },
      );
    case CONST.GET_PRODUCT_CATEGORY_DETAIL_FAILURE:
      return Object.assign(
        {},
        state,
        {
          productCategory: {},
        },
      );
    // -----------------
    // カテゴリー削除
    // -----------------
    case CONST.DELETE_PRODUCT_CATEGORY_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          isSuccess: true,
          isFailure: false,
          errorMessage: '',
        },
      );
    case CONST.DELETE_PRODUCT_CATEGORY_FAILURE:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: true,
          errorMessage: action.payload,
        },
      );
    // -----------------
    // 結果フラグクリア
    // -----------------
    case CONST.CLEAR_DELETE_PRODUCT_CATEGORY_RESULT_FLG:
      return Object.assign(
        {},
        state,
        {
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        },
      );
    default:
      return state;
  }
}

export default productCategory;
